function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.5 0C3.3547 0 0 3.3544 0 7.5C0 11.6453 3.3544 15 7.5 15C11.6453 15 15 11.6456 15 7.5C15 3.3547 11.6456 0 7.5 0ZM1.17188 7.5C1.17188 4.00239 4.00216 1.17188 7.5 1.17188C8.99344 1.17188 10.4077 1.68604 11.5413 2.6301L2.6301 11.5413C1.68604 10.4077 1.17188 8.99344 1.17188 7.5ZM7.5 13.8281C6.00656 13.8281 4.59231 13.314 3.45873 12.3699L12.3699 3.4587C13.314 4.59231 13.8281 6.00656 13.8281 7.5C13.8281 10.9976 10.9978 13.8281 7.5 13.8281Z",
  fill: "#0066FF"
});

const SvgDisableIcon = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDisableIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/disable-icon.6ed98c44.svg";
export { ForwardRef as ReactComponent };